<template>
  <div class="d-flex flex-column mx-6 mb-4">
    <div class="align-self-center">
      {{ name }}
    </div>
    <div class="d-grid custom-grid mt-2">
      <div class="grid-center-y grid-end-x">
        +{{Math.ceil(weight)}}%
      </div>
      <v-progress-linear height="20" :value="percentage" color="secondary"
                         class="grid-center-x grid-center-y"/>
      <div class="ml-2 grid-center-y grid-start-x">
        {{ value }}/{{ max }}
      </div>
    </div>
  </div>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class CompletionBar extends Vue {
  @Prop({ type: Number, required: true }) value;

  @Prop({ type: Number, required: true }) percentage;

  @Prop({ type: Number, required: true }) max;

  @Prop({ type: Number, required: true }) weight;

  @Prop({ type: String, required: true }) name;
}
</script>
<style scoped>
.custom-grid {
  row-gap: 0;
  column-gap: 10px;
  grid-template-columns: 10% auto 15%
}
</style>
